const withCodePush = (component) => component;
export default withCodePush;
